import { DTOException } from '../../../@core/models/DTOException';

export const exceptionsData: DTOException[] = [
  {
    ExceptionId: 2,
    TxtFrench: "Adresse invalide - Retour à l'expéditeur",
    TxtEnglish: 'Wrong Address - Return to sender',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 3,
    TxtFrench: "Adresse invalide. En attente de correction par l'expéditeur",
    TxtEnglish:
      'Wrong address - On hold. Waiting for correction from customer ',
    ContactAllowed: false,
    ReasonAllowed: true,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : false,
    SubExceptions: []
  },
  {
    ExceptionId: 4,
    TxtFrench: "Refusé - Retour à l'expéditeur",
    TxtEnglish: 'Refused - Return to sender',
    ContactAllowed: true,
    ReasonAllowed: false,
    TpslAllowed: true,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 5,
    TxtFrench:
      'Destinataire indisponible - Tentative de livraison le jour ouvrable suivant',
    TxtEnglish: 'Unavailable consignee - Delivery attempt on next business day',
    ContactAllowed: false,
    ReasonAllowed: true,
    TpslAllowed: true,
    PostponedDateAllowed: true,
    AdminTPSLRoute : false,
    SubExceptions: [
      {
        SubExceptionId: 200,
        TxtFrench:
          'Destinataire fermé - Nouvelle tentative le jour ouvrable suivant',
        TxtEnglish: 'Closed consignee - 2nd attempt, next business day'
      },
      {
        SubExceptionId: 201,
        TxtFrench:
          'Destinataire absent, pas de réponse - Nouvelle tentative le jour ouvrable suivant',
        TxtEnglish:
          'Absent consignee, no answer - 2nd attempt, next business day'
      },
      {
        SubExceptionId: 202,
        TxtFrench:
          "Destinataire indisponible, trop d'attente - Nouvelle tentative le jour ouvrable suivant",
        TxtEnglish:
          'Unavailable consignee, too much waiting - 2nd attempt, next business day'
      },
      {
        SubExceptionId: 203,
        TxtFrench:
          'Destinataire absent, maison privée - Nouvelle tentative le jour ouvrable suivant',
        TxtEnglish:
          'Absent consignee, private home - 2nd attempt, next business day'
      },
      {
        SubExceptionId: 204,
        TxtFrench:
          'Destinataire normalement ouvert - Nouvelle tentative le jour ouvrable suivant',
        TxtEnglish:
          'Consignee normally open - 2nd attempt on the next business day'
      }
    ]
  },
  {
    ExceptionId: 7,
    TxtFrench: "Aucune marchandise à cueillir - Annulée par l'expéditeur ",
    TxtEnglish: 'No parcel  to pickup - Canceled by shipper',
    ContactAllowed: true,
    ReasonAllowed: false,
    TpslAllowed: true,
    PostponedDateAllowed: false,
    AdminTPSLRoute : false,
    SubExceptions: []
  },
  {
    ExceptionId: 8,
    TxtFrench:
      'Paiement par COD (p.s.l.) indisponible - nouvelle tentative le jour ouvrable suivant',
    TxtEnglish: 'COD payment unavailable - 2nd attempt next business day',
    ContactAllowed: true,
    ReasonAllowed: false,
    TpslAllowed: true,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 9,
    TxtFrench: "Établissement fermé - En attente d'Instructions",
    TxtEnglish: 'Consignee closed - Waiting for instructions',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: true,
    AdminTPSLRoute : false,
    SubExceptions: []
  },
  {
    ExceptionId: 10,
    TxtFrench: "En attente d'un rendez-vous du destinataire",
    TxtEnglish: 'Waiting for appointment from consignee',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : false,
    SubExceptions: []
  },
  {
    ExceptionId: 11,
    TxtFrench:
      'Colis non disponible pour cueillette - cueillette le jour ouvrable suivant',
    TxtEnglish: 'Merchandise not ready for pickup - 2nd attempt next day',
    ContactAllowed: true,
    ReasonAllowed: false,
    TpslAllowed: true,
    PostponedDateAllowed: false,
    AdminTPSLRoute : false,
    SubExceptions: [
      {
        SubExceptionId: 110,
        TxtFrench:
          'Colis non disponible pour cueillette - Nouvelle tentative le jour ouvrable suivant',
        TxtEnglish: 'Merchandise not ready for pickup - 2nd attempt next day'
      },
      {
        SubExceptionId: 111,
        TxtFrench:
          'Colis non disponible pour cueillette (2ème avis) - Cueillette Annulée',
        TxtEnglish:
          'Merchandise not ready for pickup (2nd attempt) - Pickup Cancelled'
      }
    ]
  },
  {
    ExceptionId: 13,
    TxtFrench: 'Erreur de livraison - chauffeur',
    TxtEnglish: 'Delivery error - Driver',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 14,
    TxtFrench: 'Transit raté - Livraison reportée au jour ouvrable suivant',
    TxtEnglish: 'Missed transit - Delivery on next business day',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 15,
    TxtFrench: "Secteur non couvert par Nationex - Retour à l'expéditeur",
    TxtEnglish: 'Area not covered by Nationex - Return to sender',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 16,
    TxtFrench: 'Erreur de livraison - négligence',
    TxtEnglish: 'Delivery error - Negligence',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 17,
    TxtFrench: 'Envois partiels refusés - En attente du lot complet des colis',
    TxtEnglish: 'Incomplete shipment refused - Waiting for complete shipment',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : false,
    SubExceptions: []
  },
  {
    ExceptionId: 18,
    TxtFrench: "Colis non-recus de l'expéditeur - Livraison annulée",
    TxtEnglish: 'Parcel(s) not received from shipper - Canceled',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 19,
    TxtFrench: 'Colis indisponible pour le chargement- Livraison retardée',
    TxtEnglish: 'Parcel unavailable for loading - Delayed delivery',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 22,
    TxtFrench: 'Erreur de tri - Livraison retardée.',
    TxtEnglish: 'Sorting error - Delayed',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 23,
    TxtFrench: 'Colis indisponible pour le chargement - Livraison retardée',
    TxtEnglish: 'Parcel unavailable for loading',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 25,
    TxtFrench: 'Erreur de tri - Redirection du colis en cours',
    TxtEnglish: 'Sorting error - Re-routing in progress',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : false,
    SubExceptions: []
  },
  {
    ExceptionId: 34,
    TxtFrench: 'Recherche du colis terminée - Livraison annulée',
    TxtEnglish: 'Parcel search completed - Canceled delivery',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 36,
    TxtFrench: "Livraison retardée - Panne d'électricité",
    TxtEnglish: 'Delayed delivery - Power failure',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 37,
    TxtFrench:
      "Colis hors-dimension - Livraison impossible. Retour à l'expéditeur",
    TxtEnglish: 'Oversized parcel - Impossible to deliver. Return to sender',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 39,
    TxtFrench:
      'Conditions routières difficiles - Livraison reportée selon les conditions',
    TxtEnglish: 'Hazardous road conditions - Delivery according to conditions',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 40,
    TxtFrench:
      'Impossible de compléter la livraison - Nouvelle tentative le jour ouvrable suivant',
    TxtEnglish:
      'Unable to complete the delivery - 2nd attempt on the next business day',
    ContactAllowed: false,
    ReasonAllowed: true,
    TpslAllowed: true,
    PostponedDateAllowed: false,
    SubExceptions: [
      {
        SubExceptionId: 400,
        TxtFrench:
          'Impossible de compléter la livraison - Nouvelle tentative le jour ouvrable suivant',
        TxtEnglish:
          'Unable to complete the delivery - 2nd attempt on the next business day'
      },
      {
        SubExceptionId: 401,
        TxtFrench:
          'Impossible de compléter la livraison, temps insuffisant - Nouvelle tentative le jour ouvrable suivant',
        TxtEnglish:
          'Unable to complete the delivery, insufficient time - 2nd attempt on the next business day'
      },
      {
        SubExceptionId: 402,
        TxtFrench:
          'Impossible de compléter la livraison, conditions météo - Nouvelle tentative le jour ouvrable suivant',
        TxtEnglish:
          'Unable to complete the delivery, weather conditions - 2nd attempt on the next business day'
      },
      {
        SubExceptionId: 403,
        TxtFrench:
          'Impossible de compléter la livraison, bris mécanique - Nouvelle tentative le jour ouvrable suivant',
        TxtEnglish:
          'Unable to complete the delivery, mechanical issue - 2nd attempt on the next business day'
      },
      {
        SubExceptionId: 404,
        TxtFrench:
          "Impossible de compléter la livraison, hors des heures d'ouvertures - Nouvelle tentative le jour ouvrable suivant",
        TxtEnglish:
          'Unable to complete the delivery, out of business hours - 2nd attempt on the next business day'
      },
      {
        SubExceptionId: 405,
        TxtFrench:
          'Impossible de compléter la livraison, endroit inaccessible - Nouvelle tentative le jour ouvrable suivant',
        TxtEnglish:
          'Unable to complete the delivery, inaccessible area - 2nd attempt on the next business day'
      }
    ]
  },
  {
    ExceptionId: 41,
    TxtFrench: 'Livraison retardée – En attente d’une livraison spéciale',
    TxtEnglish: 'Delayed delivery – Waiting for a special delivery',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 42,
    TxtFrench: 'Livraison réactivée pour le jour ouvrable suivant',
    TxtEnglish: 'Delivery reactivated on next business day',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: true,
    AdminTPSLRoute : false,
    SubExceptions: []
  },
  {
    ExceptionId: 43,
    TxtFrench: 'Cueillette réactivée pour le jour ouvrable suivant',
    TxtEnglish: 'Pickup request reactivated on next business day',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : false,
    SubExceptions: []
  },
  {
    ExceptionId: 44,
    TxtFrench: 'Livraison non complétée - Reportée au jour ouvrable suivant',
    TxtEnglish:
      'Unable to complete the delivery - Delivery on next business day',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: true,
    PostponedDateAllowed: false,
    AdminTPSLRoute : false,
    SubExceptions: []
  },
  {
    ExceptionId: 45,
    TxtFrench: 'Colis retrouvé - En transit',
    TxtEnglish: 'Parcel found - In transit',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 48,
    TxtFrench: 'Livraison non complétée. Colis endommagé - Analyse en cours',
    TxtEnglish: 'Unable to complete delivery. Damaged - Analysis in progress',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 49,
    TxtFrench: "Analyse du colis complétée - Retour à l'expéditeur",
    TxtEnglish: 'Parcel analysis completed - Return to sender',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 53,
    TxtFrench: "Livraison impossible à compléter - Retour à l'expéditeur",
    TxtEnglish: 'Unable to complete the delivery - Return to sender',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 57,
    TxtFrench: 'Livraison complétée - Correction de signature en cours',
    TxtEnglish: 'Delivery completed - Signature correction in progress',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 67,
    TxtFrench: "Colis redirigé à la demande de l'expéditeur",
    TxtEnglish: "Parcel redirected at customer's request",
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 68,
    TxtFrench: 'Adresse originale exacte - Livraison le jour ouvrable suivant',
    TxtEnglish: 'Original address is valid - Delivery on next business day',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : false,
    SubExceptions: []
  },
  {
    ExceptionId: 69,
    TxtFrench: 'Livraison retardée - Livraison scolaire. Fermeture temporaire',
    TxtEnglish: 'Delayed delivery - School delivery. Temporary closure',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: true,
    AdminTPSLRoute : false,
    SubExceptions: []
  },
  {
    ExceptionId: 70,
    TxtFrench: 'Non Identifié - Réétiqueté par Nationex',
    TxtEnglish: 'Unidentified - Relabeled by Nationex',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 71,
    TxtFrench: 'Non Identifié - Mauvais transporteur',
    TxtEnglish: 'Unidentified - Wrong carrier',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 72,
    TxtFrench: "Non Identifié - Aucune donnée d'envoi",
    TxtEnglish: 'Unidentified - No shipping data',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 75,
    TxtFrench: 'Rendez-vous pour livraison le :',
    TxtEnglish: 'Appointment for delivery on:',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: true,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 77,
    TxtFrench: 'Colis réparé - Livraison le jour ouvrable suivant',
    TxtEnglish: 'Parcel repaired - Delivery on next business day',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 90,
    TxtFrench: 'Colis remis au partenaire vers la destination finale',
    TxtEnglish: 'Parcel handed to partner to final destination',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 91,
    TxtFrench: 'Demande de cueillette envoyée au partenaire',
    TxtEnglish: 'Pickup request sent to partner',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 92,
    TxtFrench: 'Colis endommagé - Livraison annulée',
    TxtEnglish: 'Parcel damaged - Canceled delivery',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 119,
    TxtFrench: 'Livraison complétée',
    TxtEnglish: 'Delivery completed',
    ContactAllowed: true,
    ReasonAllowed: false,
    TpslAllowed: true,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  },
  {
    ExceptionId: 500,
    TxtFrench: 'Livraison annulée par Nationex',
    TxtEnglish: 'Delivery canceled by Nationex',
    ContactAllowed: false,
    ReasonAllowed: false,
    TpslAllowed: false,
    PostponedDateAllowed: false,
    AdminTPSLRoute : true,
    SubExceptions: []
  }
];
